import { connect } from "react-redux";
import {
  patchEditCostLimit,
  cancelEditCostLimit,
  saveCostLimitBeingEdited
} from "./actions/costLimits";
import moment from "moment";

import EditCostLimitDialog from "./EditCostLimitDialog";

const formatDateForMUITimePicker = date => moment(date / 1000).format("YYYY-MM-DD");

const mapStateToProps = (state, ownProps) => {
  const id = state.modalForm.editCostLimit.id;

  if (!id) {
    return {
      open: false,
      costLimit: {
        isRecurring: false
      }
    };
  }

  /* this is all quite drawn out because codacy complained */
  const costLimitEntity = { ...state.entities.costLimits[id] };
  const accountId = costLimitEntity.accountId;
  const account = state.entities.accounts[accountId];
  const accountName = account && account.name;
  const costLimit = {
    ...state.modalForm.editCostLimit,
    ...costLimitEntity
  };
  
  costLimit.startDate = formatDateForMUITimePicker(costLimit.startDate);
  costLimit.endDate = formatDateForMUITimePicker(costLimit.endDate);

  return { costLimit, accountName, open: true };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSave: () => {
      dispatch(saveCostLimitBeingEdited());
    },
    onChange: patch => {
      dispatch(patchEditCostLimit(patch));
    },
    onCancel: () => {
      dispatch(cancelEditCostLimit());
    }
  };
};

const EditCostLimitDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditCostLimitDialog);

export default EditCostLimitDialogContainer;



// WEBPACK FOOTER //
// ./src/EditCostLimitDialogContainer.js